// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';


// Genetic marker represented by a code.
// Example: "TV*"

export const geneticMarkerMinLength = 1;
export const geneticMarkerMaxLength = 5;

export const GeneticMarkerSchema = t.refinement(t.string, n => n.length >= geneticMarkerMinLength && n.length <= geneticMarkerMaxLength, 'GeneticMarker');

export type GeneticMarker = string;
